import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  catchError,
  map,
  Observable,
  of,
  switchMap,
  throwError,
} from 'rxjs';
import { PeopleBarramentoResponse } from '../model/people-barramento-response';
import { ZipcodeErrorCode } from '../model/zipcode-error-code';
import { ZipcodeError } from '../model/zipcode-error';
import { environment } from '../../environments/environment';
import { RecipientCredentials } from '../types/recipient-credentials.response.type';

// Interface para representar a resposta paginada
export interface RecipientCredentialsPaged {
  content: {
    id: string;
    type: string;
    credentialNumber: string;
    processNumber: string;
    observation: string;
    status: string;
    expiringDate: string;
    createdAt: string;
    deletedAt: string;
    applicantSummary: {
      id: string;
      name: string;
    };
  };
  pageable: {
    pageNumber: number;
    pageSize: number;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
  };
  totalPages: number;
  totalElements: number;
  last: boolean;
  size: number;
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  first: boolean;
  numberOfElements: number;
  empty: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class PeopleService {
  constructor(private http: HttpClient) {}

  private apiUrl = environment.apiUrl;

  getPeopleByCpf(cpf: string): Observable<any> {
    const cleanCpf = cpf.replace(/\D/g, ''); // Remove formatação
    const timestamp = new Date().getTime(); // Timestamp atual
    const url = `${this.apiUrl}/sicred/api/v1/people/filtered?cpf=${cleanCpf}&_t=${timestamp}`;

    return this.http.get(url, { withCredentials: true });
  }

  getPeopleById(peopleId: number): Observable<any> {
    const url = `${this.apiUrl}/sicred/api/v1/people/id/${peopleId}`; // URL correta da API
    return this.http.get(url, { withCredentials: true });
  }

  getDataByCpf(cpf: string): Observable<PeopleBarramentoResponse> {
    const url = `${this.apiUrl}/sicred/api/v1/people/cpf/${cpf}`; // URL correta da API
    return this.http
      .get<PeopleBarramentoResponse>(url, { withCredentials: true })
      .pipe(
        map((data) => {
          if ('cpf' in data) {
            return data;
          }
          throw new ZipcodeError(ZipcodeErrorCode.CEP_NAO_ENCONTRADO);
        }),
        catchError((error) => {
          // Aqui você pode lidar com erros, como problemas de rede
          console.error('Erro ao buscar dados por CPF:', error);
          return throwError(() => error);
        })
      );
  }

  setPeopleData(data: any): Observable<any> {
    const url = `${this.apiUrl}/sicred/api/v1/people/addPeopleWithAddress`;
    return this.http.post(url, data, { withCredentials: true });
  }

  getPeopleCredentialsByPeopleId(recipientId: number): Observable<any> {
    const url = `${this.apiUrl}/sicred/api/v1/people/sicred/peopleid/${recipientId}`; // URL correta da API
    return this.http.get(url, { withCredentials: true });
  }

  getPeopleByName(name: string): Observable<any> {
    const url = `${this.apiUrl}/sicred/api/v1/people/filtered?name=${name}`; // URL correta da API
    return this.http.get(url, { withCredentials: true });
  }
}
